import React, { useMemo } from 'react';
import { useYotpoRefresh } from 'shared/hooks/useYotpoRefresh';
export const ReviewStars = ({ reviewId }) => {
    useYotpoRefresh(200, reviewId);
    const sourceReviewId = useMemo(() => reviewId, [reviewId]);
    return (React.createElement(React.Fragment, null, reviewId && React.createElement("div", { className: "yotpo bottomLine", "data-product-id": sourceReviewId })));
};
